import { format, subDays } from 'date-fns'

export function getDateRange(periodInDays: number): string {
  const endDate = new Date()
  const startDate = subDays(endDate, periodInDays)
  return `${format(startDate, 'dd/MM/yyyy')} - ${format(endDate, 'dd/MM/yyyy')}`
}
